export interface ChipTag {
  id: string;
  name: string;
  color: string;
  description?: string | null;
}

export function filterChipTags(tags: ChipTag[] | null | undefined): ChipTag[] {
  if (!Array.isArray(tags)) return [];
  return tags.filter((t) => !!t && !!t.id && !!t.name);
}

export function partitionChipsForRow(
  tags: ChipTag[] | null | undefined,
  max = 2
): { visible: ChipTag[]; overflow: number } {
  const list = filterChipTags(tags);
  if (list.length <= max) return { visible: list, overflow: 0 };
  return { visible: list.slice(0, max), overflow: list.length - max };
}

const AVATAR_BG_COLORS = [
  '#FEF2F2', '#FFEDD5', '#FEF9C3', '#ECFCCB',
  '#D1FAE5', '#E0F2FE', '#E0E7FF', '#F3E8FF',
  '#FCE7F3', '#FEE2E2', '#FFF7ED', '#DCFCE7',
];

const AVATAR_FG_COLORS = [
  '#991B1B', '#9A3412', '#854D0E', '#3F6212',
  '#065F46', '#075985', '#3730A3', '#6B21A8',
  '#9D174D', '#7F1D1D', '#7C2D12', '#14532D',
];

export function getAvatarColorFromId(id: string | null | undefined): {
  backgroundColor: string;
  color: string;
} {
  if (!id) return { backgroundColor: '#E5E7EB', color: '#6B7280' };
  let hash = 0;
  for (let i = 0; i < id.length; i++) {
    hash = id.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Contact ids tend to run in sequence, and the raw hash keeps that order in
  // its low bits — so a page of them all landed on the same colour. Avalanche
  // the bits before taking the bucket.
  hash ^= hash >>> 15;
  hash = Math.imul(hash, 0x2c1b3c6d);
  hash ^= hash >>> 12;
  hash = Math.imul(hash, 0x297a2d39);
  hash ^= hash >>> 15;
  const idx = Math.abs(hash) % AVATAR_BG_COLORS.length;
  return {
    backgroundColor: AVATAR_BG_COLORS[idx],
    color: AVATAR_FG_COLORS[idx],
  };
}

export function getAssigneeInitial(
  name: string | null | undefined,
  fallbackId?: string | null
): string {
  if (name) {
    const trimmed = name.trim();
    if (trimmed.length > 0) return trimmed[0].toUpperCase();
  }
  if (fallbackId) {
    const match = String(fallbackId).match(/[A-Za-z0-9]/);
    if (match) return match[0].toUpperCase();
  }
  return '?';
}
